import { Component, OnDestroy, OnInit } from '@angular/core';
import { isNotNullable, Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, Observable, Subscription, tap } from 'rxjs';
import { SimpleGalleryService } from './simple-gallery.service';
import { Iframe } from '../../store-front/misc/cms-components/iframe/iframe.model';
import { ModalService } from '../../../../components/modal-list/modal-list.service';
import { SimpleViewerImageModalComponent } from './components/simple-viewer-image-modal/simple-viewer-image-modal.component';
import { GALLERY_MEDIA_TYPE, MainContent, YOUTUBE_THUMBNAIL } from './core/simple-gallery.model';

@Component({
  selector: 'simple-gallery',
  templateUrl: './simple-gallery.component.html',
  styleUrl: './simple-gallery.component.scss',
  standalone: false,
})
export class SimpleGalleryComponent implements OnInit, OnDestroy {
  GALLERY_MEDIA_TYPE = GALLERY_MEDIA_TYPE;
  mainContent$ = this.simpleGalleryService.getContent();
  mainMediaContainer = new BehaviorSubject<any>(null);

  product$: Observable<Product> = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
    distinctUntilChanged(),
    tap((p: Product) => {
      this.mainMediaContainer.next(p.images?.['PRIMARY'] ? p.images['PRIMARY'] : {});
    }),
  );

  subscription = new Subscription();

  constructor(
    protected currentProductService: CurrentProductService,
    private simpleGalleryService: SimpleGalleryService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.getMainMedia();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getMainMedia() {
    this.subscription.add(
      combineLatest([this.product$, this.mainMediaContainer]).subscribe(([, mediaConteiner]) => {
        this.simpleGalleryService.setContent({
          type: GALLERY_MEDIA_TYPE.IMAGES,
          content: mediaConteiner,
        });
      }),
    );
  }

  setContent(content: MainContent) {
    this.simpleGalleryService.setContent(content);
  }

  getThumbVideo(videoURL: string) {
    return this.simpleGalleryService.getThumbVideo(videoURL, YOUTUBE_THUMBNAIL.MEDIUM);
  }

  getIframeVideo(videoURL: string): Iframe {
    return {
      url: videoURL,
    };
  }

  openModal(container: any) {
    this.modalService.create({
      id: 'midia-viewer',
      title: '',
      classList: 'modal-midia-viewer',
      component: SimpleViewerImageModalComponent,
      width: 940,
      data: {
        container,
      },
    });
  }
}
